import Vue from 'vue'
import App from '../App'
import VueTianditu from 'vue-tianditu'

Vue.use(VueTianditu, {
  v: '4.0',
  tk: 'ed564f9c0ee383bb453cd76d135c8fee'
})
